module.exports = __webpack_public_path__ + "img/wangpangzi.d5e71ec8.jpg";